// src/views/Markets.js

import React, { useEffect, useState } from "react";
import "./Markets.css";

const API = "/api/markets";   // ⭐ MUST USE LOCAL PROXY

export default function Markets({ mode }) {
  const [markets, setMarkets] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    try {
      const r = await fetch(API);
      const data = await r.json();
      setMarkets(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Failed to load markets:", err);
    }
    setLoading(false);
  }

  useEffect(() => {
    load();
    const interval = setInterval(load, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="Markets-loading">
        <div className="loader"></div>
        <p>Loading markets…</p>
      </div>
    );
  }

  return (
    <div className="Markets-page">
      <h1 className="Markets-title">Markets Overview</h1>
      <p className="Markets-sub">
        Real-time market data sourced from MoneyX oracle and indexer.
      </p>

      <div className="Markets-table">
        <table>
          <thead>
            <tr>
              <th>Market</th>
              <th>Price</th>
              <th>High (24h)</th>
              <th>Low (24h)</th>
              <th>Volume (24h)</th>
              <th>Open Interest</th>
              <th>Funding Rate</th>
              <th>Trade</th>
            </tr>
          </thead>

          <tbody>
            {markets.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', padding: '3rem', opacity: 0.5 }}>
                  No market data yet — data populates once trading activity begins on BESC.
                </td>
              </tr>
            ) : markets.map((m) => (
              <tr key={m.ticker_id}>
                <td className="Markets-pair">{m.ticker_id}</td>
                <td>${Number(m.last_price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 6 })}</td>
                <td>${Number(m.high).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 6 })}</td>
                <td>${Number(m.low).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 6 })}</td>
                <td>${Number(m.base_volume).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                <td>${Number(m.open_interest).toLocaleString(undefined, { maximumFractionDigits: 2 })}</td>
                <td>{(Number(m.funding_rate) * 100).toFixed(6)}%</td>
                <td>
                  <a
                    href={`https://moneyxpro.com/#/v1?market=${m.ticker_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="Markets-trade-btn"
                  >
                    Trade
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
